export const getUserToken = (state) => state.user?.token;
export const getUserCountry = (state) => state.user?.country;
export const getUserLanguage = (state) => state.user?.language;
export const getUser = (state) => state.user?.profile;
export const getAuthenticated = (state) => state.user?.authenticated;
export const getAuthPending = (state) => state.user?.authPending;
export const getAuthError = (state) => state.user?.authError;
